<template>
  <vs-table-m
    @change-page="handleChangePage"
    :sst="true"
    @selected="goToItemClicked"
    :total="result.total"
    :maxItems="pageSize"
    :data="result.items"
    pagination
    class="mt-10"
  >
    <template slot="header">
      <h4 class="m-2 my-4">{{ result.total || '' }} draft {{ contentType }}s need attention</h4>
    </template>
    <template slot="thead">
      <vs-th sort-key="name">Name</vs-th>
      <vs-th sort-key="name">Vendor</vs-th>
      <vs-th sort-key="name">Area</vs-th>
      <vs-th sort-key="has-image">Background</vs-th>
      <vs-th sort-key="has-content">Content</vs-th>
      <vs-th sort-key="modified">Modified</vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
        <vs-td :data="data[indextr].name">{{ data[indextr].name}}</vs-td>

        <vs-td :data="data[indextr].vendor">
          <vs-chip
            transparent
            v-if="data[indextr].vendor"
          >{{getVendorsEntries &&  getVendorsEntries[data[indextr].vendor] ? getVendorsEntries[data[indextr].vendor].name : ''}}</vs-chip>
        </vs-td>

        <vs-td :data="data[indextr].learning_areas">
          <div class="flex" v-if="data[indextr].learning_areas.length">
            <div class="mr-5" v-for="la in data[indextr].learning_areas" :key="la">
              <vs-chip
                transparent
              >{{getLAreasEntries && getLAreasEntries[la] ? getLAreasEntries[la].name : ''}}</vs-chip>
            </div>
          </div>
        </vs-td>

        <vs-td :data="data[indextr].images.main_image_url">
          <img :src="data[indextr].images.main_image_url" @load="imageLoaded" @error="imageError" v-show="false"/>
          <feather-icon
            v-if="!data[indextr].images.main_image_url || imagesLoaded[data[indextr].images.main_image_url] === 'error'"
            icon="XIcon"
            svgClasses="h-7 w-7 color-current text-danger"
            class="pl-8 mr-4"
          />
          <feather-icon
            v-if="imagesLoaded[data[indextr].images.main_image_url] === 'loaded'"
            icon="CheckIcon"
            svgClasses="h-7 w-7 color-current text-success"
            class="pl-8 mr-4"
          />
          <div
            class="lds-ring pl-8 mr-4"
            v-if="data[indextr].images.main_image_url && !imagesLoaded[data[indextr].images.main_image_url]"
          >
            <div></div><div></div><div></div><div></div>
          </div>
        </vs-td>

        <vs-td :data="data[indextr].content">
          <feather-icon
            v-if="data[indextr].content.length"
            icon="CheckIcon"
            svgClasses="h-7 w-7 color-current text-success"
            class="pl-5 mr-4"
          />
          <feather-icon
            v-else
            icon="XIcon"
            svgClasses="h-7 w-7 color-current text-danger"
            class="pl-5 mr-4"
          />
        </vs-td>
        <vs-td :data="data[indextr].modified">{{data[indextr].modified | dateFromFormat}}</vs-td>
      </vs-tr>
    </template>
  </vs-table-m>
</template>
<script>

import VsTableM from "@/components/VsTableM";
import { getBasicData } from '@/utils/mixins.js'

export default {
  components: {
    VsTableM
  },
  mixins: [getBasicData],
  props:{
    handleChangePage: Function,
    result: Object,
    contentType: String,
  },
  data: () => {
    return {
      pageSize: 5,
      page: 1,
      imagesLoaded: {}
    }
  },
  methods: {
    imageLoaded(e) {
      this.$set(this.imagesLoaded, e.target.src , 'loaded')
    },
    imageError(e) {
      this.$set(this.imagesLoaded, e.target.src , 'error')
    },
    goToItemClicked(e) {
      let path = ''
      switch (this.contentType) {
        case 'course':
        case 'bootcamp':
          path = `edit-${this.contentType.toLowerCase()}`
          break;
        case 'learning path':
          path = 'edit-lp'
          break;
      }
      this.$router.push({ name: path, params: { id: e.id } })
    }
  }
}
</script>
<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>